import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
  CustomButton,
  DialogBody,
  DialogContainer,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  DialogTitle,
} from '../../../common/components';
import { formatCurrency } from '../utils/fireInsuranceUtils';

const FireInsuranceImportDialog = ({ open, onClose, tableData, loading, onUpload }) => {
  return (
    <DialogContainer open={open} onClose={onClose} size="fullWidth">
      <DialogTitle>
        Se actualizarán los siguientes seguros de incendio &nbsp;&nbsp;&nbsp;
        <CustomButton
          onClick={onClose}
          variant='danger'
          startIcon={<CloseIcon />}

          sx={{
            position: 'absolute',
            left: 25,
            top: 6,
          }}
        >
          Cerrar
        </CustomButton>
        <CustomButton
          variant="warning"
          onClick={onUpload}
          startIcon={<Refresh />}
          isLoading={loading}
          sx={{
            position: 'absolute',
            right: 25,
            top: 6,
          }}
        >
          {loading ? 'Actualizando...' : 'Actualizar'}
        </CustomButton>
      </DialogTitle>

      {/* Contenido del modal */}
      <DialogBody>
        <GeneralTableBox>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Orden</HeadTableCell>
                <HeadTableCell>Plan</HeadTableCell>
                <HeadTableCell>Grupo</HeadTableCell>
                <HeadTableCell>Nuevo valor de seguro</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row, index) => {
                if (index === 0) return null; // Skip header row
                return (
                  <TableRow key={index}>
                    <RowTableCell>{row[0]}</RowTableCell>
                    <RowTableCell>{row[1]}</RowTableCell>
                    <RowTableCell>{row[2]}</RowTableCell>
                    <RowTableCell>{formatCurrency(row[3])}</RowTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </GeneralTableBox>
      </DialogBody>
    </DialogContainer>
  );
};

export default FireInsuranceImportDialog;
